import { inferLiteral } from "client/utils"
import * as types from "./types"

export const setUserSettings = (settings: types.UserSettings) => ({
    type: inferLiteral(types.SET_USER_SETTINGS),
    settings,
})

export const updateUserSettings = (
    section: keyof types.UserSettings,
    settings: types.ChangeUserSettings,
) => ({
    type: inferLiteral(types.UPDATE_USER_SETTINGS),
    data: { section, settings },
})

export const setUserSettingsReloadList = (value: boolean) => ({
    type: inferLiteral(types.USER_SETTINGS_RELOAD_LIST),
    value,
})
